/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_History_Col_NoteInputs */

const vi_sl_lot_history_col_note = /** @type {(inputs: Sl_Lot_History_Col_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã phiếu`)
};

/**

* @param {Sl_Lot_History_Col_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_history_col_note = /** @type {((inputs?: Sl_Lot_History_Col_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_History_Col_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_history_col_note(inputs)
});